/**
 *  TextArea script file
**/

export default {
  name: 'TextArea',
  mixins: [],
  components: {},
  props: {
    label: {
      type: String,
      required: false
    },
    value: {
      type: [String, Number],
      required: false
    },
    required: {
      type: Boolean,
      required: false
    },
    maxlength: {
      type: String,
      required: false
    },
    minlength: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    error: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      fieldError: null
    }
  },
  computed: {
  },
  methods: {
    onInput ($event) {
      this.$emit('input', $event.target.value)
    }
  }
}
